import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  {
    n: 1,
    title: "Planning",
    text: "We establish with you which areas are to be inspected and when we can attend.",
    imageSrc: "/media/planning-floorplan-briefing.jpg",
    imageAlt: "The team planning an inspection over a marked floor plan of the premises",
  },
  {
    n: 2,
    title: "Physical search",
    text: "Fittings, furniture, cabling and anything recently delivered or installed are examined directly for signs of tampering.",
    imageSrc: "/media/physical-search-chair-underside.jpg",
    imageAlt: "Underside of an executive chair being checked with a handheld detector during a physical search",
  },
  {
    n: 3,
    title: "Electronic detection",
    text: "Spectrum analysis, non-linear junction detection, thermal imaging and optical scanning, as the space requires.",
    imageSrc: "/media/handheld-detector-ceiling-scan.jpg",
    imageAlt: "A handheld detector scanning the ceiling line during electronic detection",
    imagePos: "50% 25%",
  },
  {
    n: 4,
    title: "Analysis and reporting",
    text: "Findings compiled into a written report identifying what was found, where, and what we recommend.",
    imageSrc: "/media/gen-reporting.jpg",
    imageAlt: "A sealed inspection report on a dark desk",
  },
];

export default function HowItRuns() {
  return (
    <section id="how-it-runs" className="py-12 sm:py-16" data-testid="how-it-runs-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>Process</Eyebrow>
          <h2 className="mt-4 font-head font-extrabold tracking-tight h-sec">
            How an inspection runs.
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-sub">
            A reading is only the start.{" "}
            <span className="text-violet">
              Each response is investigated before it is described as a device.
            </span>
          </p>
        </Reveal>

        <ol className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map(({ n, title, text, imageSrc, imageAlt, imagePos }, i) => (
            <li key={n}>
              <Reveal delay={i * 0.08} className="h-full">
                <div className="flex h-full flex-col border border-hairline bg-surface p-6" data-testid={`process-step-${n}`}>
                  <span className="text-xs font-semibold tracking-[0.16em] text-violet">
                    {String(n).padStart(2, "0")}
                  </span>
                  <h3 className="mt-3 font-head text-lg font-bold">{title}</h3>
                  <p className="mt-2 flex-1 text-base leading-relaxed text-sub">{text}</p>
                  {imageSrc && (
                    <img
                      src={imageSrc}
                      alt={imageAlt}
                      loading="lazy"
                      style={imagePos ? { objectPosition: imagePos } : undefined}
                      className="mt-5 aspect-[4/3] w-full border border-hairline object-cover"
                      data-testid={`process-step-${n}-image`}
                    />
                  )}
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
